import {
    WALLET_LOGIN_SUCCESS,
    WALLET_LOGIN_ERROR,
    WALLET_LOGIN_SUBMIT,
    WALLET_CREATION_SUCCESS,
    WALLET_CREATION_ERROR,
    WALLET_CREATION_SUBMIT,
    WALLET_SMS_SUCCESS,
    WALLET_SMS_ERROR,
    WALLET_SMS_SUBMIT,
    WALLET_FINISH_ERROR,
    WALLET_FINISH_LOAD,
    WALLET_FINISH_SUCCESS,
    WALLET_LOGIN_EXPIRED,
    WALLET_BTC_ADDRESS_ERROR,
    WALLET_BTC_ADDRESS_SUCCESS,
    WALLET_BTC_ADDRESS_LOAD,
    WALLET_LISTA_ERROR,
    WALLET_LISTA_SUBMIT,
    WALLET_LISTA_SUCCESS,
    WALLET_TOKEN_COUNT_ERROR,
    WALLET_TOKEN_COUNT_LOAD,
    WALLET_TOKEN_COUNT_SUCCESS,
    WALLET_TOKEN_ERROR,
    WALLET_TOKEN_SUBMIT,
    WALLET_TOKEN_SUCCESS,
} from '../actionTypes'

import { request } from '../../utils/api'
import { loadBrlBalance } from './wallet_brl.js'
import { fetchUserInfo } from './users'

export const finishWalletLoad = () => ({
    type: WALLET_FINISH_LOAD
})

export const finishWalletError = (message = 'Houve um erro ao criar sua wallet.') => ({
    type: WALLET_FINISH_ERROR,
    payload: {
        message
    }
})

export const finishWalletSuccess = () => ({
    type: WALLET_FINISH_SUCCESS
})

export const finishWallet = async (name, userid, form) => {
    const { code, message } = await request(`wallet/create-address/${userid}`, 'PUT', {
        name
    })   
    console.log({code, message}) 
}

export const sendSms = (userid) => async dispatch => {
    try {
        dispatch(smsSubmit())
        const { code, message } = await request(`wallet/resendSMS/${userid}`)
        if(code === 51) {
            dispatch(smsSuccess(message))
        } else {
            dispatch(smsError(message))
        }
    } catch(e) {
        dispatch(smsError(e))
    }
}

export const smsSuccess = (message = 'Código reenviado com sucesso.') => ({
    type: WALLET_SMS_SUCCESS,
    payload: {
        message
    }
})

export const smsSubmit = () => ({
    type: WALLET_SMS_SUBMIT
})

export const smsError = (message = 'Houve um erro ao reenviar o código. Tente novamente.') => ({
    type: WALLET_SMS_ERROR,
    payload: {
        message
    }
})

export const create = (id) => async dispatch => {
    try {
        dispatch(creationSubmit())
        const { token, code, message } = await request(`wallet/create/${id}`)
        if(code === 11) {
            dispatch(creationSuccess(token))
        } else {
            dispatch(creationError(message))
        }
    } catch (e) {
        dispatch(creationError(e))
    }
}

export const creationSubmit = () => ({
    type: WALLET_CREATION_SUBMIT,
})

export const creationSuccess = (token) => ({
    type: WALLET_CREATION_SUCCESS,
    payload: {
        token
    }
})

export const creationError = (message = 'Houve um erro ao criar a conta') => ({
    type: WALLET_CREATION_ERROR,
    payload: {
        message
    }
})

export const login = (pass, email, userid, page = 'all') => async dispatch => {
    try {
        dispatch(loginSubmit())
        const { code, userInfo, message, idWallet } = await request('wallet/login', 'POST', {
            password: pass,
            email: email,
            userid
        })
        if (code === 41) {
            dispatch(loginSuccess(idWallet))
            dispatch(loadBrlBalance(userid))
            if(page === '/wallet') {
                document.location.reload(true)
            }
        }
        else {
            dispatch(loginError(message))
        }
    } catch(e) {
        dispatch(loginError())
    }

}

export const loginSubmit = () => ({
    type: WALLET_LOGIN_SUBMIT
})

export const loginSuccess = (idWallet) => ({
    type: WALLET_LOGIN_SUCCESS,
    payload: {
        idWallet
    }
})

export const loginError = (message = 'Ops! Algo deu errado!') => ({
    type: WALLET_LOGIN_ERROR,
    payload: {
        message
    }
})

export const loginExpired = () => ({
    type: WALLET_LOGIN_EXPIRED
})

export const createAddress = (name, id) => async dispatch => {
    try {
        dispatch(addressLoad())
        const { code, message } = await request(`wallet/create-address/${id}`, 'PUT', {
            name
        })
        if(code === 11) {
            dispatch(addressSuccess())
        } else {
            dispatch(addressError(message))
        }
    } catch (e) {
        dispatch(addressError(e))
    }
}

export const addressLoad = () => ({
    type: WALLET_BTC_ADDRESS_LOAD
})

export const addressError = (message = 'Houve um erro ao gerar seu endereço') => ({
    type: WALLET_BTC_ADDRESS_ERROR,
    payload: {
        message
    }
})

export const addressSuccess = () => ({
    type: WALLET_BTC_ADDRESS_SUCCESS
})

export const submitLista = (userid) => async dispatch => {
    try {
        dispatch(listaSubmit())
        const { code, message } = await request(`users/request-wallet-beta/${userid}`)
        if(code === 200) {
            dispatch(fetchUserInfo(userid))
            dispatch(listaSuccess(message))
        } else {
            dispatch(listaError(message))
        }
    } catch (e) {
        dispatch(listaError(e))
    }
}

export const listaSubmit = () => ({
    type: WALLET_LISTA_SUBMIT
})

export const listaError = (message = 'Houve um erro ao entrar na lista de espera') => ({
    type: WALLET_LISTA_ERROR,
    payload: {
        message
    }
})

export const listaSuccess = (message) => ({
    type: WALLET_LISTA_SUCCESS,
    payload: {
        message
    }
})
